// CANONICAL COPY (GH #7115). src/constants/obligations/obl-acceptable-use.js re-exports this file so the browser and the
// Function App share one compliance engine — one definition of "compliant". Edit here, never there.
'use strict';

module.exports = {
  id: 'obl-acceptable-use',
  title: 'Verify acceptable use rules are in place',
  description:
    'Confirm that acceptable use rules for information and assets are documented, published, and acknowledged by all personnel.',
  category: 'assets',
  scfIds: ['SCF-AST-002'],
  cadence: { frequency: '1y', anchor: 'domain' },
  strategy: 'all',
  fulfilmentCriteria: [
    { type: 'document-published', description: 'Acceptable use policy is published' },
    { type: 'document-acknowledged', description: 'All required readers have acknowledged' },
  ],
  domainActions: [{ type: 'approve-document', label: 'Approve Document' }],
};
